export const ReportOptions = {
    responsive: true,
    scales: {
        x: {
            stacked: true,
        },
        y: {
            stacked: true,
        },
    },
    plugins: {
        legend: {
            display: false,
        },

        title: {
            display: false,
        },
    },
};

export const ReportChartColors = [
    "#17a64e",
    "#b53189",
    "#00635d",
    "#2844d1",
    "#fc7303",
    "#ac44f2",
];
